<mat-form-field appearance="outline" class="w-full">
  <mat-label>{{ label }} </mat-label>

  <input
    matInput
    [placeholder]="expectedFormatText()"
    [formControl]="control"
    (blur)="onInputBlur()"
    (input)="onManualInput($event)"
  />

  <mat-icon
    style="color: #000; width: 20px; cursor: pointer"
    matSuffix
    (click)="openDateTimePicker()"
  >
    event
  </mat-icon>

  <mat-error *ngIf="control.hasError('required')">Required field</mat-error>
  <mat-error *ngIf="control.hasError('invalidFormat')">
    Invalid date format. Expected {{ expectedFormatText() }}
  </mat-error>
  <mat-error *ngIf="control.hasError('minDate')">
    should be after
    {{ formattedMinDate()}}
  </mat-error>
</mat-form-field>
